import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    if (!this.contentTarget.classList.contains('is-hidden') && !this.contentTarget.hasAttribute('data-initial-open')) {
      this.contentTarget.classList.add('is-hidden')
    }
    this.updateIcon()
  }

  toggle(e) {
    e.preventDefault()
    this.contentTarget.classList.toggle('is-hidden')
    this.updateIcon()
  }

  updateIcon() {
    if (this.hasIconTarget) {
      const isHidden = this.contentTarget.classList.contains('is-hidden')
      this.iconTarget.classList.toggle('bi-chevron-down', isHidden)
      this.iconTarget.classList.toggle('bi-chevron-up', !isHidden)
    }
  }
}

